import { Variant } from "@flypengine/myFlyp-lib"
import * as O from "fp-ts/Option"
import * as E from "fp-ts/Either"
import * as nav from "elm-ts/lib/Navigation"
import * as Login from "./Login"
import * as Dashboard from "./Dashboard"
import * as FirebaseAuth from "firebase/auth"
import * as Router from "./routes"
import { AuthStatus } from "./Authorization"

export const _Auth = "Auth"
export const _App = "App"

export type Model =
  | Variant.Tagged<typeof _Auth, Auth>
  | Variant.Tagged<typeof _App, App>

export const Model = Variant.module<Model>({
  Auth: value => Variant.tagged(_Auth, value),
  App: value => Variant.tagged(_App, value),
})

export type Auth = {
  nextLocation: nav.Location
  login: Login.Model
}

export type App = {
  user: FirebaseAuth.User
  location: nav.Location
  contents: Page
}

// Pages
const _Dashboard = "Dashboard"
const _NotFound = "NotFound"

export type Page =
  | Variant.Tagged<typeof _Dashboard, Dashboard.Model>
  | Variant.Tagged<typeof _NotFound, void>

export const Page = Variant.module<Page>({
  Dashboard: value => Variant.tagged(_Dashboard, value),
  NotFound: value => Variant.tagged(_NotFound, value),
})

export const _navigationMsg = "navigationMsg"
export const _resetNavigationMsg = "resetNavigationMsg"
export const _dashboardMsg = "dashboardMsg"
export const _loginMsg = "loginMsg"
export const _logout = "logout"
export const _logoutRes = "logoutRes"
export const _authStateChangedMsg = "authStateChangedMsg"
export const _noOp = "noOp"

export type Msg =
  | Variant.Tagged<typeof _navigationMsg, nav.Location>
  | Variant.Tagged<typeof _resetNavigationMsg, void>
  | Variant.Tagged<typeof _dashboardMsg, Dashboard.Msg>
  | Variant.Tagged<typeof _loginMsg, Login.Msg>
  | Variant.Tagged<typeof _logout, void>
  | Variant.Tagged<typeof _logoutRes, E.Either<AuthStatus, void>>
  | Variant.Tagged<typeof _authStateChangedMsg, O.Option<FirebaseAuth.User>>
  | Variant.Tagged<typeof _noOp, void>

export const Msg = Variant.module<Msg>({
  navigationMsg: value => Variant.tagged(_navigationMsg, value),
  resetNavigationMsg: value => Variant.tagged(_resetNavigationMsg, value),
  dashboardMsg: value => Variant.tagged(_dashboardMsg, value),
  loginMsg: value => Variant.tagged(_loginMsg, value),
  logout: value => Variant.tagged(_logout, value),
  logoutRes: value => Variant.tagged(_logoutRes, value),
  authStateChangedMsg: value => Variant.tagged(_authStateChangedMsg, value),
  noOp: value => Variant.tagged(_noOp, value),
})

export const configLogin = {
  wrapperMsg: Msg.loginMsg,
}

export const configDashboard = ({
  user,
  nextLocation,
}: {
  user: FirebaseAuth.User
  nextLocation: nav.Location
}): Dashboard.Config<Msg> => ({
  wrapperMsg: Msg.dashboardMsg,
  logoutMsg: Msg.logout,
  route: Router.parseLocation(nextLocation.pathname),
  user,
})
